import { render, staticRenderFns } from "./SummaryCardOnlyScore.vue?vue&type=template&id=12f7c42e&"
import script from "./SummaryCardOnlyScore.vue?vue&type=script&lang=js&"
export * from "./SummaryCardOnlyScore.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/summary-card-only-score.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports